import { useMapEvents } from 'react-leaflet';

const MapClickHandler = ({
  mapTool,
  addCheckpointAt,
  addStartAt,
  addZoneAt,
  onZonePlaced,
  setMapTool,
  legStartsMeters,
  setZonePlacementPreview,
  editable = true,
}) => {
  useMapEvents({
    click: (e) => {
      if (!editable) return;
      const mode = mapTool?.mode || mapTool;
      if (mode === 'checkpoint') {
        const geometryType = mapTool?.geometry || 'circle';
        addCheckpointAt(e.latlng, geometryType, legStartsMeters);
        setMapTool(null);
      } else if (mode === 'zone' && typeof addZoneAt === 'function') {
        if (e?.originalEvent) {
          e.originalEvent.preventDefault?.();
          e.originalEvent.stopPropagation?.();
          e.originalEvent.stopImmediatePropagation?.();
        }
        if (mapTool?.awaitingShape && !mapTool?.shape) return;
        const shape = mapTool?.shape || 'square';
        addZoneAt(e.latlng, shape, {
          parentId: mapTool?.parentId ?? null,
          sizeMeters: mapTool?.sizeMeters,
        });
        onZonePlaced?.({
          latlng: e.latlng,
          shape,
          parentId: mapTool?.parentId ?? null,
        });
        setMapTool(null);
        setZonePlacementPreview?.(null);
      } else if (mode === 'start') {
        addStartAt(e.latlng);
        setMapTool(null);
      }
    },
    mousemove: (e) => {
      const mode = mapTool?.mode || mapTool;
      if (mode === 'zone' && !!mapTool?.shape) {
        setZonePlacementPreview?.(e.latlng);
      }
    },
    mouseout: () => {
      const mode = mapTool?.mode || mapTool;
      if (mode === 'zone') {
        setZonePlacementPreview?.(null);
      }
    },
  });
  return null;
};

export default MapClickHandler;
